import React, {Component} from 'react';
import PhoneDetail from './Components/PhoneDetail';
import ThreeSlider from "../../common/ThreeSlider";

export default class PhoneListMobileHelper extends Component {
    render(){
        let phoneList = this.props.phoneList;
        let allNotRetail = this.props.allNotRetail;
        let fiveGLabel = this.props.fiveGLabel;

        let displayItem = phoneList.map(
            (o, i) => { return (<PhoneDetail allNotRetail={allNotRetail} phoneObj={o} index={i} fiveGLabel={fiveGLabel} />) }
        )

        return(
            <div className="mobilePhoneList my-auto">
                <ThreeSlider elements={displayItem} pcdots={true} mobiledots={false} top={100} forceAllMax={1}/>
            </div>
        );
    }
}